let apiBaseUrl: string = (import.meta.env.VITE_API_URL || 'http://localhost:8080').replace(/\/$/, '')

export const setApiBaseUrl = (url: string): void => {
  apiBaseUrl = url.replace(/\/$/, '')
}

export const getApiBaseUrl = (): string => apiBaseUrl
